module.exports = __webpack_public_path__ + "img/retailer-bandlab.2c928cff.svg";